<template lang="pug">

    div

        .field
            checkbox(
                v-for='valueModel in field.values'
                v-bind:key='valueModel.id'
                v-bind:id='valueModel.id'
                v-bind:label='valueModel.value'
                v-bind:value='value'
                v-on:input='updateValue(valueModel.id, $event)'
            )

        //- Child-Fields
        dynamic-field(
            v-if="isChildVisible(directChildFieldModel)"
            v-for='directChildFieldModel in directChildFieldModels'
            v-bind:key='directChildFieldModel.id'
            v-bind:field="directChildFieldModel"
            v-bind:field-models="childFieldModels"
            v-bind:value="value"
            v-on:input="forwardPatch($event)"
        )

</template>

<script>
    import * as R from 'ramda'
    import Checkbox from './checkbox-field/Checkbox.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: {
            dynamicField: () => import('@/components/products/forms/variant-forms/form/DynamicField'),
            Checkbox
        },

        computed: {

            childFieldModels() {
                return R.compose(

                    // Alle Felder holen, die den ID-Präfix die eigene id + `-`
                    // > [ { id: "form-1-1" }, { id: "form-1-2" }, { id: "form-1-2-1" }, { id: "form-1-2-1-1" } ]
                    // < [ { id: "form-1-2-1" }, { id: "form-1-2-1-1" } ]
                    R.filter(field => R.startsWith(`${this.field.id}-`, field.id))

                )(this.fieldModels)
            },

            directChildFieldModels() {
                // naechsttieferen Level ermitteln
                const targetLevel = R.split("-", this.field.id).length + 2

                return R.compose(

                    // Alle Child-Felder holen, die sich exakt _zwei_ Level tiefer befinden
                    // > [ { id: "form-1-2-1" }, { id: "form-1-2-1-1" } ]
                    // < [ { id: "form-1-2-1-1" } ]
                    R.filter(field => R.split("-", field.id).length === targetLevel)

                )(this.childFieldModels)
            },

        },

        methods: {

            forwardPatch(value) {
                this.$emit("input", value)
            },

            isChildVisible(childFieldModel) {
                return R.compose(

                    // Pruefen ob Wert zu dieser ID existiert
                    // > "form-1-2-1"
                    // < true
                    id => R.has(id, this.value),

                    // Wieder als String zusammenfuehren
                    // > [ "form", "1", "2", "1" ]
                    // < "form-1-2-1"
                    R.join("-"),

                    // Letzten Element entfernen
                    // > [ "form", "1", "2", "1", "1" ]
                    // < [ "form", "1", "2", "1" ]
                    R.dropLast(1),

                    // ID in Array splitte
                    // > "form-1-2-1-1"
                    // < [ "form", "1", "2", "1", "1" ]
                    R.split("-"),

                )(childFieldModel.id)
            },

            remove(id) {
                R.compose(

                    // Annderung mitteilen
                    patch => this.$emit('input', patch),

                    // Wieder zu Objekt umwandeln
                    // > [ [ "form-1-1", 1 ] ]
                    // < { form-1-1: 1 }
                    R.fromPairs,

                    // Wert und "Kindswerte entfernen
                    // > [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    // < [ [ "form-1-1", 1 ] ]
                    R.reject(pair => R.startsWith(id, pair[0])),

                    // Value-Objekt in Tupel umwandeln
                    // > { form-1-1: 1, form-1-2: 2, form-1-2-1: 3 }
                    // < [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    R.toPairs

                )(this.value)
            },

            updateValue(id, value) {
                switch (value) {
                    case false:
                    case null:
                    case undefined:
                        this.remove(id)
                        break

                    default:
                        this.$emit('input', R.assoc(id, value, this.value))
                }
            }

        },

        props: {

            field: {
                type: Object,
                required: true
            },

            fieldModels: {
                type: Array,
                required: true
            },

            value: {
                required: true
            }

        },

    }

</script>
